import styled from "styled-components";
import { colors } from "@a0/quantum-web";
import { theme } from "@hub/ui/themes/theme";

export const Wrapper = styled.section`
  max-width: 121.6rem;
  margin: 0 auto 3.2rem;
  padding: 0;
  border-bottom: 0.05rem solid ${colors.neutral_n800};

  ${theme.media.tablet} {
    margin-bottom: 6.4rem;
  }

  ${theme.media.desktop} {
  }
`;

export const Title = styled.h2`
  font-family: "SpaceGrotesk", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 2rem;
  letter-spacing: 0.12rem;
  text-transform: uppercase;
  color: ${colors.neutral_n60};
  padding-bottom: 1.6rem;
  border-bottom: 0.1rem solid ${colors.neutral_n800};
  margin: 0 0 3.2rem;
`;

export const PostsWrapper = styled.div`
  padding: 3.2rem 0.4rem 4.8rem;
`;

export const PostsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  justify-content: space-between;
  gap: 2.4rem;
  overflow-x: scroll;
  border-radius: 1.6rem;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }

  ${theme.media.tablet} {
    grid-template-columns: repeat(2, 1fr);
    overflow: auto;
  }

  ${theme.media.desktop} {
    column-gap: 3.2rem;
  }
`;

export const TextContainer = styled.div`
  padding: 0 2rem;
  width: 100%;

  p:nth-child(2) {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const Post = styled.a`
  text-decoration: none;
  background: ${colors.neutral_n800};
  padding: 0.4rem 0.4rem 2.4rem;
  border-radius: 1.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2.4rem;
  transition: all 0.2s ease-in-out;

  p:first-of-type {
    position: relative;
    :after {
      content: "→";
      position: absolute;
      margin-left: 0.6rem;
      opacity: 0;
      transition: all 0.1s ease-in-out;
    }
  }

  :hover {
    p {
      text-decoration: none;
    }
    p:first-of-type:after {
      opacity: 1;
    }
    p:last-of-type {
      transition: all 0.1s ease-in-out;
      color: ${colors.neutral_white};
    }
  }

  ${theme.media.desktop} {
    padding-bottom: 3.2rem;
  }
`;

export const PostImage = styled.figure`
  width: 100%;
  height: 28rem;
  border-radius: 1.6rem 1.6rem 0 0;
  position: relative;
  overflow: hidden;
  margin: 0;

  img {
    object-fit: cover;
    object-position: top center;
  }

  ${theme.media.tablet} {
    width: 100%;
  }

  ${theme.media.desktop} {
    width: 100%;
  }
`;
